__turbopack_context__.v({
  "input": "input-number-module__YV0AMa__input",
});
